import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyD9-xrMlPbjBBandUovEAXK-2IiYvZde5o",
    authDomain: "legechcorp-eec53.firebaseapp.com",
    databaseURL: "https://legechcorp-eec53.firebaseio.com",
    projectId: "legechcorp-eec53",
    storageBucket: "legechcorp-eec53.appspot.com",
    messagingSenderId: "806309426312",
    appId: "1:806309426312:web:66f32e18ed663684475b3d",
    measurementId: "G-JZ52CHS63S"
};
const API_URL = process.env.NODE_ENV === 'development'
    ? '/api/'
    : 'https://api.legech.co.jp/';

// Firebaseアプリの初期化
const app = initializeApp(firebaseConfig);

// AuthオブジェクトとGoogleプロバイダの取得
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

/** 共通: Firebase IDトークンでAuthorizationヘッダ生成 */
const getAuthHeaders = async () => {
    const user = getAuth().currentUser;
    if (!user) throw new Error("ログインしていません");
    const token = await user.getIdToken();
    return {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
    };
};

// FirebaseでのGoogleログイン
export const loginWithGoogle = async () => {
    try {
        const result = await signInWithPopup(auth, googleProvider);
        return result.user;
    } catch (error) {
        console.error("Login failed:", error);
        throw error;
    }
};

/**
 * 全従業員取得.
 * @param {string} id x-legech-register-id
 */
export const fetchAllUserData = async (id) => {
    const url = API_URL + `users`;
    const headers = await getAuthHeaders();
    headers['x-legech-register-id'] = id;

    try {
        const response = await fetch(url, { method: 'GET', headers });
        if (!response.ok) throw new Error('Failed to fetch data');
        return await response.json();
    } catch (error) {
        console.error("fetch User API call failed:", error);
        throw error;
    }
};

/** スキル概要の取得. */
export const fetchSkillOverview = async (id) => {
    const url = API_URL + `skill/overview?firebaseId=` + id;
    const headers = await getAuthHeaders();

    try {
        const response = await fetch(url, { method: 'GET', headers });
        if (!response.ok) throw new Error('Failed to fetch data');
        return await response.json();
    } catch (error) {
        console.error("fetch User API call failed:", error);
        throw error;
    }
};

/** スキル概要の更新. */
export const updateSkillOverview = async (id, description, skills, languages) => {
    const url = API_URL + `skill/overview?firebaseId=${id}`;
    const headers = await getAuthHeaders();

    try {
        const response = await fetch(url, {
            method: 'PATCH',
            headers,
            body: JSON.stringify({
                description,
                skill: skills,
                language: languages
            })
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        console.log('Update success');
    } catch (error) {
        console.error('Failed to update skill overview:', error);
        throw error;
    }
};

/** スキル一覧を取得. */
export const fetchSkillList = async (firebaseId) => {
    const url = API_URL + `skill/individual?firebaseId=${firebaseId}`;
    const headers = await getAuthHeaders();

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers,
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const result = await response.json();
        console.log('success:', result);
        return result;
    } catch (error) {
        console.error('Failed to get skill:', error);
        throw error;
    }
};

/** スキルを登録. */
export const registerSkill = async (firebaseId, skill) => {
    const url = API_URL + `skill/individual`;
    const headers = await getAuthHeaders();

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify({
                firebaseId: firebaseId,
                company: skill.company,
                start: skill.start,
                end: skill.end,
                overview: skill.overview,
                detail: skill.detail,
                technology: skill.technology,
                lang: skill.lang,
                role: skill.role,
                development_count: skill.development_count,
                total_count: skill.total_count,
                highlight: skill.highlight,
                visible: skill.visible,
                isSideProject: skill.isSideProject,
            })
        });
        if (!response.ok) throw new Error('Network response was not ok.');

        const data = await response.json(); // { id: "newSkillId" } を想定
        console.log('Success:', data);
        return data.id;
    } catch (error) {
        console.error('Failed to get skill:', error);
        return "";
    }
};

/** スキルを更新. */
export const updateSkill = async (skillId, firebaseId, skill) => {
    const url = API_URL + `skill/individual?skillId=` + skillId;
    const headers = await getAuthHeaders();

    try {
        const response = await fetch(url, {
            method: 'PATCH',
            headers,
            body: JSON.stringify({
                firebaseId: firebaseId,
                company: skill.company,
                start: skill.start,
                end: skill.end,
                overview: skill.overview,
                detail: skill.detail,
                technology: skill.technology,
                lang: skill.lang,
                role: skill.role,
                development_count: skill.development_count,
                total_count: skill.total_count,
                highlight: skill.highlight,
                visible: skill.visible,
                isSideProject: skill.isSideProject,
            })
        });
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }
        console.log('Success');
    } catch (error) {
        console.error('Failed to update skill:', error);
        throw error;
    }
};

/** 個別スキルを削除. */
export const deleteSkill = async (skillId) => {
    const url = API_URL + `skill/individual?skillId=${skillId}`;
    const headers = await getAuthHeaders();

    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers,
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        console.log('delete success');
    } catch (error) {
        console.error('Failed to delete skill:', error);
        throw error;
    }
};

/** スキルを一括インポート. */
export const importSkill = async (importJson) => {
    const url = API_URL + `skill/import`;
    const headers = await getAuthHeaders();

    try {
        const parsedJson = JSON.parse(importJson);
        const response = await fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify(parsedJson)
        });
        if (!response.ok) {
            throw new Error('Network response was not ok.');
        }
        console.log('import success');
    } catch (error) {
        console.error('Failed to import skill:', error);
        throw error;
    }
};

/** デイレポ送信. */
export const postDayrepo = async (
    firebaseId,
    emoji,
    message,
    legechId,
    slackMemberId,
    inputUrl
) => {
    const url = API_URL + `report/dayrepo`;
    const headers = await getAuthHeaders();

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify({
                firebaseId,
                emoji,
                message,
                legechId,
                slackId: slackMemberId,
                url: inputUrl
            })
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        console.log('dayrepo send success');
    } catch (error) {
        console.error('Failed send dayrepo:', error);
        throw error;
    }
};

/** ウィーレポ一覧取得. */
export const fetchWeerepo = async (id, limit, offset) => {
    const url = API_URL + `report/weerepo?firebaseId=${id}&limit=${limit}&offset=${offset}`;
    const headers = await getAuthHeaders();

    try {
        const response = await fetch(url, { method: 'GET', headers });
        if (!response.ok) {
            throw new Error('Failed to fetch data');
        }
        return await response.json();
    } catch (error) {
        console.error('fetch weerepo failed:', error);
        throw error;
    }
};

/** 個別ウィーレポを取得. */
export const fetchWeerepoDetail = async (id) => {
    const url = API_URL + `report/weerepo/${id}`;
    const headers = await getAuthHeaders();

    try {
        const response = await fetch(url, { method: 'GET', headers });
        if (!response.ok) {
            throw new Error('Failed to fetch data');
        }
        return await response.json();
    } catch (error) {
        console.error('fetch weerepo detail failed:', error);
        throw error;
    }
};

/** デイレポ一覧取得. */
export const fetchDayrepo = async (id, limit, offset) => {
    const url = API_URL + `report/dayrepo?firebaseId=${id}&limit=${limit}&offset=${offset}`;
    const headers = await getAuthHeaders();

    try {
        const response = await fetch(url, { method: 'GET', headers });
        if (!response.ok) {
            throw new Error('Failed to fetch data');
        }
        return await response.json();
    } catch (error) {
        console.error('fetch dayrepo failed:', error);
        throw error;
    }
};

/** ウィーレポの登録. */
export const postWeerepo = async (
    firebaseId,
    slackId,
    legechId,
    workEmoji,
    mentalEmoji,
    works,
    insideWorks,
    content
) => {
    const url = API_URL + `report/weerepo`;
    const headers = await getAuthHeaders();

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify({
                firebaseId,
                slackId,
                legechId,
                workEmoji,
                mentalEmoji,
                works,
                insideWorks,
                content
            })
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        console.log('weerepo send success');
    } catch (error) {
        console.error('Failed send weerepo:', error);
        throw error;
    }
};

/** ウィーレポに対するコメントを送信. */
export const postWeerepoComment = async (weerepoId, firebaseId, content) => {
    const url = API_URL + `report/comment/weerepo`;
    const headers = await getAuthHeaders();

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify({
                weerepoId,
                firebaseId,
                content
            })
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        console.log('Comment send success');
    } catch (error) {
        console.error('Failed to send comment:', error);
        throw error;
    }
};

/** 休業日一覧取得 */
export const fetchClosedDays = async (from, to) => {
    const url = API_URL + `holiday/closed-days?from=${from}&to=${to}`;
    const headers = await getAuthHeaders();

    try {
        const response = await fetch(url, { method: 'GET', headers });
        if (!response.ok) {
            throw new Error(`Failed to fetch closed days: ${response.status}`);
        }
        return await response.json();      // [{ id, date, name, kind }, ...] を想定
    } catch (error) {
        console.error('fetch closedDays failed:', error);
        throw error;
    }
};

/** 休業日登録 */
export const createClosedDay = async ({ date, name, kind }) => {
    const url = API_URL + `holiday/closed-days`;
    const headers = await getAuthHeaders();

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify({ date, name, kind })
        });
        if (!response.ok) {
            throw new Error(`Failed to create closed day: ${response.status}`);
        }
        return await response.json();      // { message, id }
    } catch (error) {
        console.error('create closedDay failed:', error);
        throw error;
    }
};

/** 休業日更新 */
export const updateClosedDay = async (id, { date, name, kind }) => {
    const url = API_URL + `holiday/closed-days/${id}`;
    const headers = await getAuthHeaders();

    try {
        const response = await fetch(url, {
            method: 'PATCH',
            headers,
            body: JSON.stringify({ date, name, kind })
        });
        if (!response.ok) {
            throw new Error(`Failed to update closed day: ${response.status}`);
        }
        return await response.json();      // { message }
    } catch (error) {
        console.error('update closedDay failed:', error);
        throw error;
    }
};

/** 休業日削除 */
export const deleteClosedDay = async (id) => {
    const url = API_URL + `holiday/closed-days/${id}`;
    const headers = await getAuthHeaders();

    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers,
        });
        if (!response.ok) {
            throw new Error(`Failed to delete closed day: ${response.status}`);
        }
        return await response.json();      // { message }
    } catch (error) {
        console.error('delete closedDay failed:', error);
        throw error;
    }
};

/** 書籍購入申請. */
export const postBookRequest = async (firebaseId, legechId, slackId, url, note) => {
    const apiUrl = API_URL + `request/book`;
    const headers = await getAuthHeaders();

    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers,
            body: JSON.stringify({ firebaseId, legechId, slackId, url, note })
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    } catch (error) {
        console.error('Failed to post book request:', error);
        throw error;
    }
};

/** 健康診断希望日申請. */
export const postHealthCheck = async (firebaseId, legechId, slackId, type, timeSlot, date1, date2, date3, note) => {
    const url = API_URL + `request/health-check`;
    const headers = await getAuthHeaders();

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify({ firebaseId, legechId, slackId, type, timeSlot, date1, date2, date3, note })
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    } catch (error) {
        console.error('Failed to post health check:', error);
        throw error;
    }
};

/** 勤怠連絡. */
export const postAttendance = async (firebaseId, legechId, slackId, type, date, note) => {
    const url = API_URL + `request/attendance`;
    const headers = await getAuthHeaders();

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify({ firebaseId, legechId, slackId, type, date, note })
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    } catch (error) {
        console.error('Failed to post attendance:', error);
        throw error;
    }
};

/** 営業日情報の取得. */
export const fetchBusinessDays = async (months = 3, lowTime = 140) => {
    const url = API_URL + `holiday/working-summary?months=${months}&lowTime=${lowTime}`;
    const headers = await getAuthHeaders();

    try {
        const response = await fetch(url, { method: 'GET', headers });
        if (!response.ok) {
            throw new Error(`Failed to fetch business days: ${response.status}`);
        }
        // { basicTime, lowTime, months: [ ... ] } を想定
        return await response.json();
    } catch (error) {
        console.error('fetch businessDays failed:', error);
        throw error;
    }
};
